import React from 'react';
import useFormHandler from 'hooks/useFormHandler';
import { Button, DynamicForm } from 'components';
import { Props } from 'types/modals';
import Base from '../../base';
import schema from './schema';

const GetAllModal = ({ closing, onClose }: Props) => {
  const formHandler = useFormHandler(schema);

  const handleSubmit = () => {
    formHandler.setIsSubmitting(true);
    onClose({ backgroundCheck: formHandler.data.backgroundCheck });
  };

  return (
    <Base
      header="Get all employees"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={<Button text="Done" disabled={!formHandler.valid || formHandler.isSubmitting} onClick={handleSubmit} />}
    >
      <DynamicForm handler={formHandler} />
    </Base>
  );
};

export default GetAllModal;
